import React from 'react';
import { Link } from 'gatsby';
import ReactMoment from 'react-moment';

import './blog-card.styles.scss';
export interface BlogCardProps {
  title: string;
  url: string;
  thumbnailUrl: string;
  author: {
    name: string;
    profilePicUrl: string;
  };
  publishedAt: string;
}

export function BlogCard({
  title,
  url,
  thumbnailUrl,
  publishedAt,
  author: { name, profilePicUrl },
}: BlogCardProps) {
  return (
    <div className="single-blog-post bg-fffbf5">
      <div className="post-image">
        <Link to={url}>
          <img src={thumbnailUrl} alt="blog post thumbnail" />
        </Link>
      </div>

      <div className="post-content">
        <ul className="post-meta d-flex justify-content-between align-items-center">
          <li>
            <div className="post-author d-flex align-items-center">
              <img
                src={profilePicUrl}
                className="rounded-circle"
                alt="profile"
              />
              <span>{name}</span>
            </div>
          </li>
          <li>
            <i className="flaticon-calendar"></i>{' '}
            <ReactMoment format="MMMM Do YYYY">{publishedAt}</ReactMoment>
          </li>
        </ul>
        <h3>
          <Link to={url}>{title}</Link>
        </h3>
      </div>
    </div>
  );
}

export default BlogCard;
